export const SET_SEARCH_BAR_DATA = "SET_SEARCH_BAR_DATA";
export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
export const SET_CLICKED = "SET_CLICKED";
export const SET_PANEL = "SET_PANEL";
